import { NgModule } from '@angular/core';

import { TextMaskModule } from 'angular2-text-mask';

@NgModule({
  exports: [
    TextMaskModule
  ]
})
export class ValidatorsModule {}


// WEBPACK FOOTER //
// ./src/validators/validators.module.ts